import React, { useState, useEffect, useRef } from "react";
import styles from "./styles/InputFile.module.css";
import Button from "../button/Button";

const InputFile = ({
    label,
    inputId,
    inputValue,
    handleChangeFunction,
    rastFile,
}) => {
    const [fileContent, setFileContent] = useState("");
    const [fileName, setFileName] = useState("");
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (inputValue) {
            setFileContent(inputValue.content || "");
            setFileName(inputValue.fileName || "");
        } else {
            setFileContent("");
            setFileName("");
        }
    }, [inputValue]);

    const handleFileContent = (event) => {
        const file = event?.target?.files?.[0];
        if (file) {
            const reader = new FileReader();

            // Check if it's an SVG or image file
            if (file.type === "image/svg+xml") {
                // Read SVG as text
                reader.onload = (e) => {
                    const content = e.target.result;
                    setFileContent(content);
                    setFileName(file.name);
                    handleChangeFunction({
                        target: {
                            name: inputId,
                            value: { fileName: file.name, content: content },
                        },
                    });
                };
                reader.readAsText(file);
            } else if (
                file.type === "image/jpeg" ||
                file.type === "image/jpg" ||
                file.type === "image/png"
            ) {
                // Read JPG/PNG as base64
                reader.onload = (e) => {
                    const content = e.target.result; // This will be a base64 data URL
                    setFileContent(content);
                    setFileName(file.name);
                    handleChangeFunction({
                        target: {
                            name: inputId,
                            value: { fileName: file.name, content: content },
                        },
                    });
                };
                reader.readAsDataURL(file);
            }
        }
    };

    return (
        <div className={`${styles.input_container} v-flex-container`}>
            <label className={styles.input_label} htmlFor={inputId}>
                {label}
                {label ? ":" : ""}
            </label>

            <div className={`${styles.output_element}`}>
                {fileName || "No file selected"}
            </div>
            <div className={`${styles.file_button}`}>
                <Button
                    body={fileName ? "change file" : "select file"}
                    size="small"
                    type="button"
                    onClickFuction={() => fileInputRef.current.click()}
                />
            </div>
            <input
                className={styles.input_element}
                type="file"
                accept={rastFile ? ".jpg,.jpeg,.png" : ".svg"}
                name={inputId}
                id={inputId}
                onChange={handleFileContent}
                ref={fileInputRef}
            />
        </div>
    );
};

export default InputFile;

// import React, { useState, useEffect, useRef } from "react";
// import styles from "./styles/InputFile.module.css";
// import Button from "../button/Button";

// const InputFile = ({
//     label,
//     inputId,
//     inputValue,
//     handleChangeFunction,
//     jpgFile,
// }) => {
//     const [fileContent, setFileContent] = useState("");
//     const [fileName, setFileName] = useState("");
//     const fileInputRef = useRef(null);

//     useEffect(() => {
//         if (inputValue) {
//             setFileContent(inputValue.content || "");
//             setFileName(inputValue.fileName || "");
//         } else {
//             setFileContent("");
//             setFileName("");
//         }
//     }, [inputValue]);

//     const handleFileContent = (event) => {
//         const file = event?.target?.files?.[0];
//         if (file) {
//             const reader = new FileReader();

//             // Check if it's an SVG or JPG
//             if (file.type === "image/svg+xml") {
//                 // Read SVG as text
//                 reader.onload = (e) => {
//                     const content = e.target.result;
//                     setFileContent(content);
//                     setFileName(file.name);
//                     handleChangeFunction({
//                         target: {
//                             name: inputId,
//                             value: { fileName: file.name, content: content },
//                         },
//                     });
//                 };
//                 reader.readAsText(file);
//             } else if (
//                 file.type === "image/jpeg" ||
//                 file.type === "image/jpg"
//             ) {
//                 // Read JPG as base64
//                 reader.onload = (e) => {
//                     const content = e.target.result; // This will be a base64 data URL
//                     setFileContent(content);
//                     setFileName(file.name);
//                     handleChangeFunction({
//                         target: {
//                             name: inputId,
//                             value: { fileName: file.name, content: content },
//                         },
//                     });
//                 };
//                 reader.readAsDataURL(file);
//             }
//         }
//     };

//     return (
//         <div className={`${styles.input_container} v-flex-container`}>
//             <label className={styles.input_label} htmlFor={inputId}>
//                 {label}
//                 {label ? ":" : ""}
//             </label>

//             <div className={`${styles.output_element}`}>
//                 {fileName || "No file selected"}
//             </div>
//             <div className={`${styles.file_button}`}>
//                 <Button
//                     body={fileName ? "change file" : "select file"}
//                     size="small"
//                     type="button"
//                     onClickFuction={() => fileInputRef.current.click()}
//                 />
//             </div>
//             <input
//                 className={styles.input_element}
//                 type="file"
//                 accept={jpgFile ? ".jpg,.jpeg" : ".svg"}
//                 name={inputId}
//                 id={inputId}
//                 onChange={handleFileContent}
//                 ref={fileInputRef}
//             />
//         </div>
//     );
// };

// export default InputFile;
